import { Col } from 'antd';
import React from 'react';

type Props = {
  label?: String;
};

const FormSectionTitle: React.FC<Props> = props => {
  return (
    <div className="form-section-title">
      <Col span="24">
        <label>{props.label}</label>
      </Col>
    </div>
  );
};

export default FormSectionTitle;
